module.exports = __webpack_public_path__ + "vrsafety/static/media/Forward.892db513.png";